const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

const getTempFileRenderUrl = (tempFilename, type) => {
    return `${apiEndpoint}/render/temp?tempFilename=${tempFilename}&type=${type}`;
}

const getFileRenderUrl = (groupType, id, fileName) => {
    return `${apiEndpoint}/render/attach/${groupType}/${id}/${fileName}`;
}

const getGalleryRenderUrl = (groupType, path, fileName) => {
    return `${apiEndpoint}/render/gallery/${groupType}?filename=${fileName}&path=${path}`;
}

const getGalleryVideoRenderUrl = (groupType, path, fileName) => {
    return `${apiEndpoint}/render/gallery/${groupType}?filename=${fileName}&path=${path}`;
}

const downloadGalleryVideoUrl = (groupType, path, fileName) => {
    return `${apiEndpoint}/render/download/${groupType}?filename=${fileName}&path=${path}`
}


const getResponseFile = (file) => {
    if (file.status === 'done') {
        const { response } = file;
        return response.bean;
    }
    return null;
}

const composeUrlInFileList = (fileList) => {
    return fileList.map((item) => {
        if (item.status === 'done') {
            const file = getResponseFile(item);
            if (file.tempFilename) {
                return {
                    ...item,
                    url: getTempFileRenderUrl(file.tempFilename, file.type),
                };
            }
        }
        return item;
    });
}

const convertFileBeanToFileAnt = (uid, fileBean, { groupType, id }) =>{
    const { originalFilename } = fileBean;
    return {
        uid: uid,
        name: originalFilename,
        status: 'done',
        url: getFileRenderUrl(groupType, id, originalFilename),
        response: { bean: { ...fileBean } },
    };
}

const fileUtils = {
    getTempFileRenderUrl,
    getFileRenderUrl,
    getGalleryRenderUrl,
    composeUrlInFileList,
    convertFileBeanToFileAnt,
    getGalleryVideoRenderUrl,
    downloadGalleryVideoUrl,
}

export default fileUtils;